import { z } from 'zod'

export const WORK_TASK_TRACKER_ATTACHMENT_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerAttachmentResponseSchema = z.unknown()
export type WorkTaskTrackerAttachmentResponse = z.infer<typeof workTaskTrackerAttachmentResponseSchema>
